import { TaxReportForm } from "@/constants/TaxReportForm";

export enum TaxObligationLiabilityType {
    FORM_941_MEDICARE = 'FORM_941_MEDICARE',
    FORM_941_SST = 'FORM_941_SST',
    FORM_941_FIT = 'FORM_941_FIT',
    FORM_940_FUT = 'FORM_940_FUT',
    FORM_1120_FEDERAL_INCOME_TAX = 'FORM_1120_FEDERAL_INCOME_TAX',
    FORM_1120_STATE_TAX = 'FORM_1120_STATE_TAX',
    FORM_1120_CITY_TAX = 'FORM_1120_CITY_TAX',
    FORM_1120S_STATE_FRANCHISE_TAX = 'FORM_1120S_STATE_FRANCHISE_TAX',
    FORM_1120S_CITY_FRANCHISE_TAX = 'FORM_1120S_CITY_FRANCHISE_TAX',
    FORM_1065_STATE_TAX = 'FORM_1065_STATE_TAX',
    SALES_TAX = 'SALES_TAX',
    USE_TAX = 'USE_TAX',
    ANNUAL_REPORT_STATE_FEE = 'ANNUAL_REPORT_STATE_FEE',
    FORM_NYS_45_STATE = 'FORM_NYS_45_STATE',
    FORM_NYS_45_CITY = 'FORM_NYS_45_CITY',
    FORM_NYS_45_STATE_UNEMPLOYMENT = 'FORM_NYS_45_STATE_UNEMPLOYMENT',
    FORM_NYS_45_REEMPLOYMENT_SERVICE_FUND = 'FORM_NYS_45_REEMPLOYMENT_SERVICE_FUND',
    FORM_RT_6_STATE_TAX = 'FORM_RT_6_STATE_TAX',
    FLORIDA_STATE_UNEMPLOYMENT_SUTA = 'FLORIDA_STATE_UNEMPLOYMENT_SUTA',
    NEW_JERSEY_STATE_TAX = 'NEW_JERSEY_STATE_TAX',
    NEW_JERSEY_SDI = 'NEW_JERSEY_SDI',
    NEW_JERSEY_FAMILY_LEAVE_INSURANCE = 'NEW_JERSEY_FAMILY_LEAVE_INSURANCE',
    NEW_JERSEY_EMPLOYER_SDI = 'NEW_JERSEY_EMPLOYER_SDI',
    NEW_JERSEY_STATE_UNEMPLOYMENT_SUTA = 'NEW_JERSEY_STATE_UNEMPLOYMENT_SUTA',
    FORM_NJ_927_STATE_TAX = 'FORM_NJ_927_STATE_TAX',
    FORM_WR_30_STATE_TAX = 'FORM_WR_30_STATE_TAX',
    FORM_CT_941_STATE_TAX = 'FORM_CT_941_STATE_TAX',
    FORM_DE_9_STATE_TAX = 'FORM_DE_9_STATE_TAX',
    CALIFORNIA_STATE_TAX = 'CALIFORNIA_STATE_TAX',
    CALIFORNIA_STATE_UNEMPLOYMENT_SUTA = 'CALIFORNIA_STATE_UNEMPLOYMENT_SUTA',
    CALIFORNIA_EMPLOYMENT_TRAINING_TAX = 'CALIFORNIA_EMPLOYMENT_TRAINING_TAX',
    CALIFORNIA_SDI = 'CALIFORNIA_SDI',
    TAX_BILL = 'TAX_BILL',
    FINAL_REPORT = 'FINAL_REPORT',
    FORM_NYS_45_YONKERS = 'FORM_NYS_45_YONKERS'
}

export function getTaxObligationLiabilityTypeLabel(type: TaxObligationLiabilityType): string {
    switch (type) {
        case TaxObligationLiabilityType.FORM_941_MEDICARE: return "Form 941 Medicare";
        case TaxObligationLiabilityType.FORM_941_SST: return "Form 941 Social Security Tax";
        case TaxObligationLiabilityType.FORM_941_FIT: return "Form 941 Federal Income Tax";
        case TaxObligationLiabilityType.FORM_940_FUT: return "Form 940 Federal Unemployment Tax";
        case TaxObligationLiabilityType.FORM_1120_FEDERAL_INCOME_TAX: return "Form 1120 Federal Income Tax";
        case TaxObligationLiabilityType.FORM_1120_STATE_TAX: return "Form 1120 State Tax";
        case TaxObligationLiabilityType.FORM_1120_CITY_TAX: return "Form 1120 City Tax";
        case TaxObligationLiabilityType.FORM_1120S_STATE_FRANCHISE_TAX: return "Form 1120S State Franchise Tax";
        case TaxObligationLiabilityType.FORM_1120S_CITY_FRANCHISE_TAX: return "Form 1120S City Franchise Tax";
        case TaxObligationLiabilityType.FORM_1065_STATE_TAX: return "Form 1065 State Tax";
        case TaxObligationLiabilityType.SALES_TAX: return "Sales Tax";
        case TaxObligationLiabilityType.USE_TAX: return "Use Tax";
        case TaxObligationLiabilityType.ANNUAL_REPORT_STATE_FEE: return "Annual Report State Fee";
        case TaxObligationLiabilityType.FORM_NYS_45_STATE: return "New York State";
        case TaxObligationLiabilityType.FORM_NYS_45_CITY: return "New York City";
        case TaxObligationLiabilityType.FORM_NYS_45_STATE_UNEMPLOYMENT: return "New York State Unemployment (SUTA)";
        case TaxObligationLiabilityType.FORM_NYS_45_REEMPLOYMENT_SERVICE_FUND: return "New York Re-employment Service Fund";
        case TaxObligationLiabilityType.FORM_NYS_45_YONKERS: return "New York Yonkers Tax";
        case TaxObligationLiabilityType.FORM_RT_6_STATE_TAX: return "Form RT-6 State Tax";
        case TaxObligationLiabilityType.FLORIDA_STATE_UNEMPLOYMENT_SUTA: return "Florida State Unemployment (SUTA)";
        case TaxObligationLiabilityType.FORM_NJ_927_STATE_TAX: return "Form NJ-927 State Tax";
        case TaxObligationLiabilityType.NEW_JERSEY_STATE_TAX: return "New Jersey State Tax";
        case TaxObligationLiabilityType.NEW_JERSEY_SDI: return "New Jersey State Disability Insurance";
        case TaxObligationLiabilityType.NEW_JERSEY_FAMILY_LEAVE_INSURANCE: return "New Jersey Family Leave Insurance";
        case TaxObligationLiabilityType.NEW_JERSEY_EMPLOYER_SDI: return "New Jersey Employer State Disability Insurance";
        case TaxObligationLiabilityType.NEW_JERSEY_STATE_UNEMPLOYMENT_SUTA: return "New Jersey State Unemployment (SUTA)";
        case TaxObligationLiabilityType.FORM_WR_30_STATE_TAX: return "Form WR-30 State Tax";
        case TaxObligationLiabilityType.FORM_CT_941_STATE_TAX: return "Form CT-941 State Tax";
        case TaxObligationLiabilityType.FORM_DE_9_STATE_TAX: return "Form DE-9 State Tax";
        case TaxObligationLiabilityType.CALIFORNIA_STATE_TAX: return "California State Tax";
        case TaxObligationLiabilityType.CALIFORNIA_STATE_UNEMPLOYMENT_SUTA: return "California State Unemployment (SUTA)";
        case TaxObligationLiabilityType.CALIFORNIA_EMPLOYMENT_TRAINING_TAX: return "California Employment Training Tax";
        case TaxObligationLiabilityType.CALIFORNIA_SDI: return "California State Disability Insurance";
        case TaxObligationLiabilityType.TAX_BILL: return "Tax Bill";
        case TaxObligationLiabilityType.FINAL_REPORT: return "Final Report";
        default: return type;
    }
}

export const TaxObligationLiabilityMapping: Record<TaxReportForm, TaxObligationLiabilityType[]> = {
    [TaxReportForm.FORM_941]: [
        TaxObligationLiabilityType.FORM_941_FIT,
        TaxObligationLiabilityType.FORM_941_SST,
        TaxObligationLiabilityType.FORM_941_MEDICARE,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_940]: [
        TaxObligationLiabilityType.FORM_940_FUT,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_1120]: [
        TaxObligationLiabilityType.FORM_1120_FEDERAL_INCOME_TAX,
        TaxObligationLiabilityType.FORM_1120_STATE_TAX,
        TaxObligationLiabilityType.FORM_1120_CITY_TAX,
    ],
    [TaxReportForm.FORM_1120S]: [
        TaxObligationLiabilityType.FORM_1120S_STATE_FRANCHISE_TAX,
        TaxObligationLiabilityType.FORM_1120S_CITY_FRANCHISE_TAX,
    ],
    [TaxReportForm.FORM_1065]: [
        TaxObligationLiabilityType.FORM_1065_STATE_TAX,
    ],
    [TaxReportForm.SALES_TAX_REPORT]: [
        TaxObligationLiabilityType.SALES_TAX,
        TaxObligationLiabilityType.USE_TAX,
    ],
    [TaxReportForm.ANNUAL_REPORT]: [
        TaxObligationLiabilityType.ANNUAL_REPORT_STATE_FEE,
    ],
    [TaxReportForm.FORM_NYS_45]: [
        TaxObligationLiabilityType.FORM_NYS_45_STATE,
        TaxObligationLiabilityType.FORM_NYS_45_CITY,
        TaxObligationLiabilityType.FORM_NYS_45_STATE_UNEMPLOYMENT,
        TaxObligationLiabilityType.FORM_NYS_45_REEMPLOYMENT_SERVICE_FUND,
        TaxObligationLiabilityType.FORM_NYS_45_YONKERS,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_RT_6]: [
        TaxObligationLiabilityType.FLORIDA_STATE_UNEMPLOYMENT_SUTA,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_NJ_927]: [
        TaxObligationLiabilityType.NEW_JERSEY_STATE_TAX,
        TaxObligationLiabilityType.NEW_JERSEY_SDI,
        TaxObligationLiabilityType.NEW_JERSEY_FAMILY_LEAVE_INSURANCE,
        TaxObligationLiabilityType.NEW_JERSEY_EMPLOYER_SDI,
        TaxObligationLiabilityType.NEW_JERSEY_STATE_UNEMPLOYMENT_SUTA,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_WR_30]: [
        TaxObligationLiabilityType.FORM_WR_30_STATE_TAX,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_CT_941]: [
        TaxObligationLiabilityType.FORM_CT_941_STATE_TAX,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.FORM_DE_9]: [
        TaxObligationLiabilityType.CALIFORNIA_STATE_TAX,
        TaxObligationLiabilityType.CALIFORNIA_STATE_UNEMPLOYMENT_SUTA,
        TaxObligationLiabilityType.CALIFORNIA_EMPLOYMENT_TRAINING_TAX,
        TaxObligationLiabilityType.CALIFORNIA_SDI,
        TaxObligationLiabilityType.FINAL_REPORT,
    ],
    [TaxReportForm.TAX_BILL]: [
        TaxObligationLiabilityType.TAX_BILL
    ]
};

/**
 * Возвращает список обязательств, которые должны быть предзаполнены по умолчанию для конкретной формы.
 */
export function getDefaultLiabilitiesForForm(form: TaxReportForm): TaxObligationLiabilityType[] {
    switch (form) {
        case TaxReportForm.FORM_941:
            return [
                TaxObligationLiabilityType.FORM_941_FIT,
                TaxObligationLiabilityType.FORM_941_SST,
                TaxObligationLiabilityType.FORM_941_MEDICARE,
            ];

        case TaxReportForm.FORM_RT_6:
            return [
                TaxObligationLiabilityType.FLORIDA_STATE_UNEMPLOYMENT_SUTA
            ];
        case TaxReportForm.FORM_NJ_927:
            return [
                TaxObligationLiabilityType.NEW_JERSEY_STATE_TAX,
                TaxObligationLiabilityType.NEW_JERSEY_SDI,
                TaxObligationLiabilityType.NEW_JERSEY_FAMILY_LEAVE_INSURANCE,
                TaxObligationLiabilityType.NEW_JERSEY_EMPLOYER_SDI,
                TaxObligationLiabilityType.NEW_JERSEY_STATE_UNEMPLOYMENT_SUTA,
            ];
        case TaxReportForm.FORM_DE_9:
            return [
                TaxObligationLiabilityType.CALIFORNIA_STATE_TAX,
                TaxObligationLiabilityType.CALIFORNIA_STATE_UNEMPLOYMENT_SUTA,
                TaxObligationLiabilityType.CALIFORNIA_EMPLOYMENT_TRAINING_TAX,
                TaxObligationLiabilityType.CALIFORNIA_SDI,
            ];

        case TaxReportForm.FORM_940:
        case TaxReportForm.FORM_1065:
        case TaxReportForm.ANNUAL_REPORT:
        case TaxReportForm.FORM_WR_30:
        case TaxReportForm.FORM_CT_941:
            return [TaxObligationLiabilityMapping[form][0]];

        case TaxReportForm.FORM_NYS_45:
            return [
                TaxObligationLiabilityType.FORM_NYS_45_STATE,
                TaxObligationLiabilityType.FORM_NYS_45_CITY,
                TaxObligationLiabilityType.FORM_NYS_45_STATE_UNEMPLOYMENT,
                TaxObligationLiabilityType.FORM_NYS_45_REEMPLOYMENT_SERVICE_FUND,
            ];

        case TaxReportForm.FORM_1120S:
            return [
                TaxObligationLiabilityType.FORM_1120S_STATE_FRANCHISE_TAX,
                TaxObligationLiabilityType.FORM_1120S_CITY_FRANCHISE_TAX
            ];

        case TaxReportForm.FORM_1120:
            return [TaxObligationLiabilityType.FORM_1120_FEDERAL_INCOME_TAX];

        case TaxReportForm.SALES_TAX_REPORT:
            return [TaxObligationLiabilityType.SALES_TAX];

        case TaxReportForm.TAX_BILL:
            return [TaxObligationLiabilityType.TAX_BILL];

        default:
            return [];
    }
}
